import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';

@Injectable()
export class BasicAthInterceptor implements HttpInterceptor {

  currentToken: string;

  constructor(private storageService: StorageService) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes(('authorize'))) {
      request = request.clone({
        headers: new HttpHeaders({
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": `Basic ${window.btoa("5fw1y-q0477-r0gKx-8CcGh-vTJdh:Jr0QPbS5L7Bui7UfIiNNxVqTd3c8Ep1aAwzmK6owDkzDh__xUe-l")}`
        })
      })
    }

    if (request.url.includes('token') && !request.url.includes('validate')) {
      request = request.clone({
        headers: new HttpHeaders({
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": `Basic ${window.btoa("Io77z-cB2OL-fFPw9-4s5MD-Eiex1:Alh1a18hGbslio0axcRt4kLmMbto0WjdcE36gy5vllf6s5S8EnoaT2ie__m01-cZi")}`
        })
      })
    }

    if (request.url.includes('aseguradora') && request.url.includes('pago')) {
      if (this.storageService.ifExist('currentToken')) {
        this.currentToken = this.storageService.getItem('currentToken');
        request = request.clone({
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": `Bearer ${this.currentToken}`
          })
        })
      }
    }

    return next.handle(request);
  }
}
